<section class="why-showcase">
  <div class="showcase-shell">
    <h2 class="showcase-title">
      Simplify Operations Maximize <span>Growth</span>
    </h2>

    <p class="showcase-subtitle">
      Run your business smoothly with one powerful ERP platform.
    </p>

    <div class="showcase-arrow" aria-hidden="true">
      <img src="images/webps/blue-arrow.png" alt="" />
    </div>

    <div class="showcase-stage">
      <div class="shape shape-left" aria-hidden="true"></div>
      <div class="shape shape-right" aria-hidden="true"></div>

      <div class="screen-frame">
        <div class="screen-image-slot">
          <video
            #demoVideo
            class="screen-image"
            poster="images/webps/main.png"
            playsinline
            (click)="togglePlay()"
            (timeupdate)="onTimeUpdate()"
            (play)="isPlaying = true"
            (pause)="isPlaying = false"
            (ended)="isPlaying = false"
          >
            <source src="images/common/salemobilizer.webm" type="video/webm" />
            <source src="images/common/salevideo.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>

    <div class="showcase-controls">
      <button
        type="button"
        class="control-pause"
        [class.is-playing]="isPlaying"
        (click)="togglePlay()"
        [attr.aria-label]="isPlaying ? 'Pause video' : 'Play video'"
      ></button>
      <div class="control-line" (click)="seek($event)">
        <div class="control-progress" [style.width.%]="progress"></div>
        <div class="control-dot" [style.left.%]="progress"></div>
      </div>
    </div>
  </div>
</section>